import { Component, OnInit, Inject } from '@angular/core';

import { AuthenticationService } from '../../login/authentication.service';

import { MenutitleService } from '../../../shared/menutitle.service';
import { ShowmenuService } from '../../..//shared/showmenu.service';

import { Router, ActivatedRoute } from '@angular/router';

import { UnixtimeService } from '../../../shared/unixtime.service';
import { BeepService } from '../../../shared/beep.service';
import { VibrateService } from '../../../shared/vibrate.service';

import { NgxIndexedDBService } from 'ngx-indexed-db';

import { MatSnackBar } from '@angular/material/snack-bar';

import { MenucontentService } from '../../../shared/menucontent.service';

import { UploadcounterService } from '../../../shared/uploadcounter.service';

import { BarcodeFormat } from '@zxing/library';
import { BehaviorSubject } from 'rxjs';
import { ViewChild } from '@angular/core';
import { ZXingScannerComponent } from '@zxing/ngx-scanner';

import { MatDialog, MAT_DIALOG_DATA } from '@angular/material/dialog';

export interface DialogData {
  dialogtitle: string;
  dialogtext: string;
}

@Component({
  selector: 'app-scan',
  templateUrl: './scan.component.html',
  styleUrls: ['./scan.component.css'],
})
export class ScanComponent implements OnInit {
  //qrResultString: any;
  @ViewChild('scanner', { static: false })
  scanner: ZXingScannerComponent;

  //https://embed.plnkr.co/MN4riU/
  //hasCameras = false;
  //hasPermission: boolean;

  showmenu: boolean;
  timing_json: any;
  stage_type: string;

  selectedCamera = null;
 
  showThemePink=true;

  loading = true;
  availableDevices: MediaDeviceInfo[];
  currentDevice: MediaDeviceInfo = null;

  /*
  formatsEnabled: BarcodeFormat[] = [
    BarcodeFormat.CODE_128,
    BarcodeFormat.DATA_MATRIX,
    BarcodeFormat.EAN_13,
    BarcodeFormat.QR_CODE,
  ];
  */

  formatsEnabled: BarcodeFormat[] = [BarcodeFormat.QR_CODE];

  //hasDevices: boolean;
  //hasPermission: boolean;

  qrResultString: string;

  torchEnabled = false;
  torchAvailable$ = new BehaviorSubject<boolean>(false);
  tryHarder = true;

  gotokeyboard() {
    var stage_type = localStorage.getItem('global_stage_type');
    this.router.navigate(['/type/' + stage_type]);
  }

  onCodeResult(resultString: string) {
    /*
    var item = {
      type: 'time', 
      client_id: localStorage.getItem("global_client_id"),
      device_id: localStorage.getItem("global_device_id"),
      client_pin: localStorage.getItem("global_client_pin"),
      mass_start_id: 0,
      stage_type: localStorage.getItem("global_stage_type"),
      race_number: qr_code, 
      tagged_time: unix_time_now(),
      user_name: localStorage.getItem("global_user_name"),
    };
*/
    this.BeepService.beep();
    this.VibrateService.vibrate();
    this.qrResultString = resultString;
    var unix_time = this.UnixtimeService.unixtime();
    var stage_type = localStorage.getItem('global_stage_type');

    this.timing_json = {
      type: 'time',
      client_id: localStorage.getItem('global_client_id'),
      device_id: localStorage.getItem('global_device_id'),
      client_pin: localStorage.getItem('global_client_pin'),
      mass_start_id: 0,
      stage_type: stage_type,
      race_number: this.qrResultString,
      tagged_time: unix_time,
      user_name: localStorage.getItem('global_user_name'),
    };

    this.dbService
      .add('timingmobi', {
        json: this.timing_json,
      })
      .subscribe((key) => {
        //console.log('key: ', key);

        //this.openSnackBar('QR code: '+this.qrResultString, 'OK')
        this.openSnackBar(this.qrResultString, 'OK');

        this.dbService.count('timingmobi').subscribe((peopleCount) => {
          this.UploadcounterService.changeUploadTotal(peopleCount);
        });
      });
  }

  openSnackBar(message: string, action: string) {
    this._snackBar.open(message, action, {
      duration: 2000,
    });
  }

  onCamerasFound(devices: MediaDeviceInfo[]): void {
    this.availableDevices = devices;

    var  cameraCount = 0;

    //console.log(typeof this.availableDevices);

    //console.log(JSON.stringify(this.availableDevices));

    var a = 1;

    this.availableDevices.forEach(function (cameraObject) {
      var cameraLabel = cameraObject.label;
      var cameraDirection = '';

      if (cameraLabel.includes('front')) {
        cameraDirection = ' (Front)';
      }
      if (cameraLabel.includes('back')) {
        cameraDirection = ' (Back)';
        cameraCount++;
      }

      // Object.defineProperty(cameraObject, label, { writable: true});

      Object.defineProperty(cameraObject, 'label', {
        value: 'Camera ' + a + cameraDirection,
        writable: true,
      });

      a++;
    });

    //console.log(cameraCount)
    //console.log(localStorage.getItem('global_camera_popup'))
    //cameraCount++;
    //cameraCount++;

    //cameraCount = 5;
    //localStorage.setItem('global_camera_popup', 'No');

    if (
      cameraCount > 1 &&
      localStorage.getItem('global_camera_popup') != 'Yes'
    ) {
      this.openDialog(cameraCount);
      localStorage.setItem('global_camera_popup', 'Yes');
    } else if (localStorage.getItem('global_camera_popup') != 'Yes') {
      this.openDialog(0);
      localStorage.setItem('global_camera_popup', 'Yes');
    }

    console.log('CAMERA DONE');

    setTimeout(() => this.cameraStartUp(), 1000);

  }

  cameraStartUp() {
    this.scanner.device = null;

    // if camera already selected
    var current_camera = localStorage.getItem('global_current_camera');
    if (current_camera != null) {
      this.onDeviceSelectChange(current_camera);
    }

    this.loading = false;
  }

  onDeviceSelectChange(selected: string) {
    //alert(selected)
    //console.log('----------------------');
    //console.log(selected);
    //console.log('----------------------');
    localStorage.setItem('global_current_camera', selected);

    this.selectedCamera = selected;

    //this.scanner.device  = null;

    const device = this.availableDevices.find((x) => x.deviceId === selected);
    //alert(device)
    //console.log('!!!!!' + device);
    this.scanner.device = device || null;
    //this.scanner.device = device;
  }

  constructor(
    private menutitle: MenutitleService,
    private AuthenticationService: AuthenticationService,
    private router: Router,
    private route: ActivatedRoute,
    private ShowmenuService: ShowmenuService,
    private UnixtimeService: UnixtimeService,
    private dbService: NgxIndexedDBService,
    private _snackBar: MatSnackBar,
    private BeepService: BeepService,
    private VibrateService: VibrateService,
    private MenucontentService: MenucontentService,
    private UploadcounterService: UploadcounterService,
    public dialog: MatDialog
  ) {}

  ngOnInit(): void {
    this.AuthenticationService.check_logged_in();
    this.AuthenticationService.save_current_route();

    this.ShowmenuService.currentshowMenu.subscribe(
      (showmenu) => (this.showmenu = showmenu)
    );

    this.ShowmenuService.changeShowmenu(true);
    this.MenucontentService.changeMenuMassStart();
    this.MenucontentService.changeMenuIndividualStart();
    this.MenucontentService.changeCheckpoints();

    this.route.paramMap.subscribe((params) => {
      this.stage_type = params.get('stage_type');

      localStorage.setItem('global_stage_type', this.stage_type);
      this.menutitle.changeMenutitle(this.stage_type);

      if (this.stage_type=='Individual Start'){
        this.menutitle.showMenupink(false);
        this.showThemePink=false;
      } else {
        this.menutitle.showMenupink(true);
        this.showThemePink=true;
      }
  
      //console.log('Theme: '+this.showThemePink)
      
    });



    localStorage.setItem('global_input_method', 'scan');
    //this.loading = false;

    console.log('INIT DONE');

    //var current_camera = localStorage.getItem('global_current_camera');

    //if (current_camera === null){
    //  this.onDeviceSelectChange(current_camera);
    //
    // }
  }
  openDialog(camera_amount) {
    if (camera_amount <= 0) {
      var dialog_text =
        ' Close this popup and click the dropdown to select a camera';

      this.dialog.open(DialogCameraCounter, {
        height: '230px',
        width: '350px',
        data: { dialogtitle: 'Choose a camera', dialogtext: dialog_text },
      });
    } else {
      var dialog_text =
        'You have ' +
        camera_amount +
        ' cameras on the back of your device.<br /><br />Close this popup and click the dropdown to select a camera.<br /><br />Test all the cameras on the back of your device to find the best one for QR number scanning.';

      this.dialog.open(DialogCameraCounter, {
        height: '330px',
        width: '350px',
        data: {
          dialogtitle: 'Choose the best camera',
          dialogtext: dialog_text,
        },
      });
    }
  }
}

@Component({
  selector: 'dialog-elements2',
  templateUrl: 'camera.dialog.html',
})
export class DialogCameraCounter {
  constructor(
    @Inject(MAT_DIALOG_DATA) public data: DialogData,
    public dialog: MatDialog
  ) {}
}
